module.exports = __webpack_public_path__ + "assets/img/imte1.c1ed4f6c.png";